<template>
  <div class="bright-points" v-if="list.length>0">
    <div class="title">
      <img
        class="pc-title"
        src="https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-title2.png"
        alt
      />
      <img
        class="m-title"
        src="https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-title2.png"
        alt
      />
    </div>
    <div class="box">
      <swiper
        :options="swiperOption"
        ref="mySwiper"
        v-if="list.length>0"
        @slideChange="slideChange"
      >
        <!-- slides -->
        <swiper-slide :key="index" v-for="(item ,index) in list" :data="item.title">
          <img class="item" :src="item.img" alt="轮播" />
        </swiper-slide>
        <!-- Optional controls -->

        <!-- <div class="swiper-scrollbar" slot="scrollbar"></div>
        <div class="swiper-pagination" slot="pagination"></div>-->
      </swiper>
      <div id="bright-points-prev" class="swiper-button-prev" v-if="list.length>=2"></div>
      <div id="bright-points-next" class="swiper-button-next" v-if="list.length>=2"></div>
      <!-- <div class="prev" v-if="list.length>=2" slot="button-prev"></div>
      <div class="next" v-if="list.length>=2" slot="button-next"></div>-->
      <div class="bottom">{{text}}</div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import XHR from '../api'

import 'swiper/dist/css/swiper.css'
export default {
  name: 'BrightPoints',
  props: [],
  data: () => ({
    list: [],
    text: '',
    swiperOption: {
      // loop: true,
      // 滚动条
      // scrollbar: {
      //   el: '.swiper-scrollbar'
      // },
      // 上一张，下一张
      navigation: {
        nextEl: '#bright-points-next',
        prevEl: '#bright-points-prev'
      },
      // autoplay: {
      //   delay: 1000, // 秒
      //   stopOnLastSlide: false,
      //   disableOnInteraction: false
      // },
      autoplayDisableOnInteraction: false,
      autoplayStopOnLastSlide: false
    }
  }),
  components: {
    swiper,
    swiperSlide
  },
  created () {
  },
  mounted () {
    this.getBrightPoints()
  },
  methods: {
    getBrightPoints () {
      XHR.getBrightPoints().then((res) => {
        const { status, data } = res.data
        if (status === 0) {
          this.list = data
          this.text = data[0].title
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    slideChange () {
      const swiperIndex = this.$refs.mySwiper.swiper.activeIndex
      this.text = this.list[swiperIndex].title || ''
    }
  }
}
</script>
<style lang="less" scoped>
.bright-points {
  margin-top: 78px;
}
.title {
  .pc-title {
    display: none;
  }
  .m-title {
    margin: 0 auto;
    display: block;
    width: 300px;
  }
}
.box {
  position: relative;
  margin: 0 auto;
  background-size: cover;
  background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-box2.png");
  width: 540px;
  height: 460px;
  padding: 3px;
  box-sizing: border-box;
  .swiper-container {
    box-sizing: border-box;
    margin: 20px 0 0 0;
    border-top-left-radius: 40px;
    border-top-right-radius: 40px;
    .item {
      border-top-left-radius: 40px;
      border-top-right-radius: 40px;
      height: 100%;
      width: 100%;
    }
  }
  #bright-points-prev {
    outline: none;
    position: absolute;
    left: -80px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    background-size: cover;
    background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-left.png");
    width: 60px;
    height: 100px;
  }
  #bright-points-next {
    outline: none;
    position: absolute;
    right: -80px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    background-size: cover;
    background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-right.png");
    width: 60px;
    height: 100px;
  }
  .bottom {
    padding: 0 20px;
    background-color: rgba(0, 0, 0, 0.8);
    // bottom: 3px;
    // left: 3px;
    // right: 3px;
    height: 77px;
    border-bottom-left-radius: 40px;
    border-bottom-right-radius: 40px;
    font-size: 32px;
    color: rgb(255, 255, 255);
    text-align: center;
    line-height: 77px;
    z-index: 100;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media screen and (min-width: 751px) {
  .title {
    .pc-title {
      margin: 0 auto;
      display: block;
      width: 380px;
    }
    .m-title {
      display: none;
    }
  }
  .box {
    background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-box2.png");
    width: 750px;
    height: 520px;
    .prev {
      position: absolute;
      left: -100px;
      top: 0;
      bottom: 0;
      margin: auto 0;
      background-size: cover;
      background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-left.png");
      width: 80px;
      height: 100px;
    }
    .next {
      position: absolute;
      right: -100px;
      top: 0;
      bottom: 0;
      margin: auto 0;
      background-size: cover;
      background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-right.png");
      width: 80px;
      height: 100px;
    }
    .swiper-container {
      box-sizing: border-box;
      margin: 20px 0 0 0;
      border-radius: 40px;
      .item {
        border-radius: 40px;
        height: 494px;
        width: 100%;
      }
    }
    .bottom {
      position: absolute;
      padding: 0 20px;
      background-color: rgba(0, 0, 0, 0.8);
      bottom: 3px;
      left: 3px;
      right: 3px;
      height: 77px;
      border-bottom-left-radius: 40px;
      border-bottom-right-radius: 40px;
      font-size: 32px;
      color: rgb(255, 255, 255);
      text-align: center;
      line-height: 77px;
      z-index: 100;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
